import React    from 'react';
import Link     from '@material-ui/core/Link';

import Logo     from 'assets/logo.png';

function Component () {
	return (
		<Link href="/classroom/register" className="link-color">
			<img src={Logo} className="login-nav-logo" alt="none"/>
		</Link>
	);
}

export default Component;
